import { fetchCountries } from 'syft-acp-core/api/resources/countries'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('COUNTRIES_FETCH', fetchCountries)
}
